const loadedImages = new Set();

export default {
  inserted(el) {
  //  let imageSrc = encodeURI(el.dataset.src);
    let imageSrc = el.dataset.src;
    if (!imageSrc) return;

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {

          // Nếu ảnh này đã được load rồi → chỉ gán src (không cần observer nữa)
          if (loadedImages.has(imageSrc)) {
            el.src = imageSrc;
            observer.unobserve(el);
            return;
          }

          // Đánh dấu ảnh đã load
          loadedImages.add(imageSrc);

          el.src = imageSrc;

          observer.unobserve(el);
        }
      });
    };

    const observer = new IntersectionObserver(callback);
    observer.observe(el);
  }
};
